import { cuisines } from "../utils/Cuisines"
import CuisineTile from "./CuisineTile"

export default function CuisineStrip(){

    return (
        <div className="w-[80%] container mx-auto mt-16 mb-16">
            <h2 className="font-display text-2xl font-semibold text-charcoal mb-6">What are you craving?</h2>
            <div className="flex flex-wrap gap-4">
                {
                    cuisines.map((cuisine)=><CuisineTile key={cuisine.name} cuisine={cuisine}></CuisineTile>)
                }
            </div>
        </div>
    )
}
